/*
  BEELTRA V1 -- placeholder rotativo del Smart Search. Solo decorativo:
  el <input> real conserva su placeholder nativo (accesible, funciona
  sin JS). Este span solo anima EJEMPLOS mientras el campo esta vacio y
  sin foco -- nunca reemplaza texto que el usuario haya escrito.
*/
(function () {
  var ROTATE_MS = 5000;

  function init(field) {
    var input = field.querySelector('[data-smart-search-input]');
    var ghost = field.querySelector('[data-smart-search-ghost]');
    if (!input || !ghost) return;

    var examples = window.__beeltraSmartSearchPlaceholders;
    if (!examples || !examples.length) return;

    var prefersReducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var index = 0;
    var timer = null;

    function shouldShow() {
      return document.activeElement !== input && input.value.trim() === '';
    }

    function render() {
      ghost.textContent = examples[index];
      ghost.classList.toggle('is-visible', shouldShow());
    }

    function advance() {
      index = (index + 1) % examples.length;
      ghost.classList.remove('is-visible');
      window.setTimeout(function () {
        render();
      }, 220);
    }

    function schedule() {
      if (timer) clearInterval(timer);
      if (prefersReducedMotion) return;
      timer = setInterval(advance, ROTATE_MS);
    }

    input.addEventListener('focus', function () {
      ghost.classList.remove('is-visible');
    });
    input.addEventListener('blur', render);
    input.addEventListener('input', function () {
      ghost.classList.toggle('is-visible', shouldShow());
    });

    render();
    schedule();
  }

  document.querySelectorAll('[data-smart-search-field]').forEach(init);
})();
